import { useInfiniteQuery } from '@tanstack/react-query';
import { api } from '../api';

export function useFeed() {
  return useInfiniteQuery({
    queryKey: ['feed'],
    queryFn: ({ pageParam }) => api.feed.get({ next: pageParam }),
    initialPageParam: undefined as string | undefined,
    // BE walks ASC (oldest of the alive set first); `next` cursor
    // points forward to newer alive avatars. Null when feed is fully
    // walked.
    getNextPageParam: (lastPage) => lastPage.next ?? undefined,
  });
}
